import { render, staticRenderFns } from "./SalesTopCustomerTable.vue?vue&type=template&id=a51c5378"
import script from "./SalesTopCustomerTable.vue?vue&type=script&lang=ts"
export * from "./SalesTopCustomerTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports